module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "breadcrumbs"
  }, _vm._l((_vm.list), function(item) {
    return _c('li', {
      staticClass: "breadcrumbs__items"
    }, [(item.href || item.to) ? [(item.href === "/" || item.href === "/new" || (item.to && item.to.path === "/") || (item.to && item.to.path === "/new") || (item.to && item.to === "/")) ? _c('a', {
      staticClass: "breadcrumbs__link externalLink",
      on: {
        "click": function($event) {
          return _vm.breadCrumbsClick(item.href || item.to)
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _c('ext-link', {
      staticClass: "breadcrumbs__link",
      attrs: {
        "to": item.href || item.to
      }
    }, [_vm._v(_vm._s(item.text))])] : _c('span', {
      staticClass: "breadcrumbs__text",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })], 2)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7749822","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/BreadCrumbs.vue
// module id = a8c6413685041399a2af
// module chunks = 0